import Button, { ButtonProps } from 'react-bootstrap/Button';
import LoadingSpinner from './LoadingSpinner';

type Props = {
  loading?: boolean;
} & ButtonProps;

const LoadingButton = ({ loading, disabled, children, ...rest }: Props) => {
  return (
    <Button {...rest} disabled={disabled || loading}>
      <div className="d-flex align-items-center justify-content-center">
        <LoadingSpinner
          wrapperClassName="d-inline-flex"
          show={loading}
          small
          className="mr-1"
        />
        {children}
      </div>
    </Button>
  );
};
export default LoadingButton;
